<template>
	<div class="brand_box">
		<div class="brand_title">
			管理&nbsp;<i class="el-icon-right"></i>
		</div>
		<dv-border-box-13>
			<div class="manageList">
				<div class="manageItem" v-for="(item,index) in manageList" :key="index">
					<img :src="item.path">
					<div>
						<div class="manageItem_title">{{item.title}}</div>
						<div class="manageItem_num">
							<countTo :startVal='0' :endVal='Number(item.num)' :duration='800'></countTo>
						家</div>
					</div>
				</div>
			</div>
		</dv-border-box-13>
		<div class="brand_chart">
			<div id="createChart2" style="width:100%;height:100%;"></div>
		</div>
		<div class="btn">服务类商标注册量前十</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				manageList:[
					{
						path:require('@/assets/brand/manage-1.png'),
						title:'商标品牌基地',
						num:130,
					},{
						path:require('@/assets/brand/manage-2.png'),
						title:'商标品牌示范企业',
						num:989,
					},{
						path:require('@/assets/brand/manage-3.png'),
						title:'商标代理机构',
						num:1341,
					}
				],
			}
		},
		mounted() {},
		methods:{
			getData(data){
				this.drawChart2(data)
			},
			drawChart2(list) {
				let myChart = this.$echarts.init(document.getElementById('createChart2'));
				for(var i in list){
					list[i].value = list[i].count
				}
				var option = {
					color: ['#FC6060','#2DB8FB','#FFA620','#24FEB4','#FF7875', '#9E43DE','#FFF049','#3DABFF','#69BA6D','#B96BC6'],
					tooltip: {
						show: false,
					},
					legend: {
						show: true, // 是否显示图列
						left: '10%',
						// top:'5'
						bottom: '0',
						icon: "rect", // 修改形状
						itemWidth: 10,
						itemHeight: 10,
						textStyle: {
							color: '#fff',
							fontSize:12,
						},
						
						data:list.map(item =>item.name),
					},
					series: [
						{
							name: 'Access From',
							type: 'pie',
							center: ['50%', '40%'],
							radius: ['60%', '75%'],
							avoidLabelOverlap: false,
							label: {
								show: false,
								position: 'center',
								fontSize: '12px'
							},
							labelLine: {
								show: false
							},
							emphasis: {
								label: {
									show: true,
									color: '#fff',
									fontSize:14,
									formatter: `{d}%\n\n{b}`
								}
							},
							data:list
						}
					],
				}
				var currentIndex = 0;
				var timer = 0;
				function animate() {
					timer = setInterval(function() {
						var dataLen = option.series[0].data.length;
						// 取消之前高亮的图形
						myChart.dispatchAction({
							type: 'downplay',
							seriesIndex: 0,
							dataIndex: currentIndex,
						});
						currentIndex = (currentIndex + 1) % dataLen;
						// 高亮当前图形
						myChart.dispatchAction({
							type: 'highlight',
							seriesIndex:0,
							dataIndex: currentIndex,
						});
					}, 1400);
				}
				animate();
				// 用户鼠标悬浮到某一图形时，停止自动切换并高亮鼠标悬浮的图形
				myChart.on("mouseover", function(e) {
					clearInterval(timer);
					// 取消之前高亮的图形
					myChart.dispatchAction({
						type: 'downplay',
						seriesIndex: 0,
					});
					myChart.dispatchAction({
						type: 'highlight',
						dataIndex: e.dataIndex
					});
				});
				// 用户鼠标移出时，重新开始自动切换
				myChart.on("mouseout", function(e) {
					currentIndex = e.dataIndex;
					animate();
				});
				myChart.setOption(option);
				window.addEventListener("resize", function() {
					myChart.resize();
				});
			},
		}
	}
</script>

<style>
</style>
